module.exports = __webpack_public_path__ + "media/images/front/about/dba_logo-889e574029316f82457d4f85007d6216.png";